import axios from 'axios';
import posthog from 'posthog-js';
class AuditLogService {
    static auth;
    static config;
    constructor(auth, config) {
        AuditLogService.auth = auth;
        AuditLogService.config = config;
    }
    headers() {
        return {
            Authorization: `Bearer ${AuditLogService.auth.currentToken}`,
        };
    }
    adminPortal = {
        query: async (entityType, entityID) => {
            // Takes entityType and entityID, not offset and limit
            try {
                const response = await axios({
                    method: 'GET',
                    url: `${AuditLogService.config.API.baseApiUrl}/audit-trail/for-entity/${entityType}/${entityID}`,
                    headers: this.headers(),
                });
                return response;
            }
            catch (error) {
                posthog.captureException(error);
                return { status: 'error', data: [] };
            }
        },
    };
}
export default AuditLogService;
//# sourceMappingURL=AuditLog.service.js.map